'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/weather/Weather.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var WeatherIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3608 8.13237C9.92008 8.04548 9.46501 8 9 8C5.13401 8 2 11.134 2 15C2 18.866 5.13401 22 9 22H16.5C19.5376 22 22 19.5376 22 16.5C22 14.612 21.0489 12.9478 19.6019 11.9578C19.8581 11.3561 20 10.694 20 10C20 7.23858 17.7614 5 15 5C12.8984 5 11.1007 6.29596 10.3608 8.13237ZM12.2499 8.79875C13.3326 9.36718 14.2475 10.2104 14.9027 11.2358C15.4088 11.0824 15.9453 11 16.5 11C16.9374 11 17.3636 11.0512 17.7727 11.1482C17.9192 10.795 18 10.4075 18 10C18 8.34315 16.6569 7 15 7C13.7708 7 12.7131 7.73998 12.2499 8.79875Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 1V3.5H14V1H16ZM9.69531 2.78244L11.4631 4.55021L10.0489 5.96442L8.2811 4.19666L9.69531 2.78244ZM21.715 4.19666L19.9472 5.96442L18.533 4.55021L20.3008 2.78244L21.715 4.19666ZM21.5 8.5H24V10.5H21.5V8.5Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

// src/weather/WeatherOutlined.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var WeatherOutlinedIcon = (props) => /* @__PURE__ */ jsx2(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 1V3.5H14V1H16ZM9.69531 2.78244L11.4631 4.55021L10.0489 5.96442L8.2811 4.19666L9.69531 2.78244ZM21.715 4.19666L19.9472 5.96442L18.533 4.55021L20.3008 2.78244L21.715 4.19666ZM10.3608 8.13238C9.9201 8.04548 9.46502 8 9 8C5.13401 8 2 11.134 2 15C2 18.866 5.13401 22 9 22H16.5C19.5376 22 22 19.5376 22 16.5C22 14.612 21.0489 12.9478 19.6019 11.9578C19.8583 11.3557 20 10.6935 20 10C20 7.23858 17.7614 5 15 5C12.8979 5 11.1006 6.29649 10.3608 8.13238ZM12.2499 8.79874C13.3326 9.36716 14.2475 10.2104 14.9027 11.2358C15.4088 11.0824 15.9453 11 16.5 11C16.9374 11 17.3636 11.0512 17.7727 11.1482C17.9191 10.7953 18 10.4079 18 10C18 8.34315 16.6569 7 15 7C13.7712 7 12.7132 7.73949 12.2499 8.79874ZM9 10C6.23858 10 4 12.2386 4 15C4 17.7614 6.23858 20 9 20H16.5C18.433 20 20 18.433 20 16.5C20 15.0479 19.1155 13.8001 17.8519 13.2704C17.4373 13.0965 16.9812 13 16.5 13C15.9246 13 15.3844 13.1381 14.9079 13.382L13.9802 13.8569L13.544 12.9104C12.9881 11.704 11.9651 10.7563 10.7092 10.2995C10.1772 10.106 9.6021 10 9 10ZM21.5 8.5H24V10.5H21.5V8.5Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  WeatherIcon,
  WeatherOutlinedIcon
};
//# sourceMappingURL=chunk-HI5E5OL2.mjs.map